<div id="wrapper" class="{{wrapperClass}}">
    <!-- <ag-webtemplate-loading></ag-webtemplate-loading> -->
    <header id="appHeader" *ngIf="!inCustomerZone">
        <div class="navbar navbar-default clearfix" role="navigation">
            <a *ngIf="(currentBrand === Brand.AG) || !currentBrand" class="navbar-brand" data-overlay-trigger="true"
                href="https://www.aginsurance.be">
                <img src="{{this.configService.configuration.logoUrl}}" alt="AG Insurance">
            </a>
            <a *ngIf="currentBrand === Brand.Digital" class="navbar-brand" (click)="GoToHome()">
                <img src="assets/images/logo-aginsurance.svg" alt="AG logo" />
            </a>
            <a *ngIf="currentBrand === Brand.Broker" class="navbar-brand" data-overlay-trigger="true"
                href="{{brokerWebsiteUrl ? 'https://'+brokerWebsiteUrl : './'+RouteNames.simulation+'/'+RouteNames.simulationLanding}}">
                <!-- Adding the ngIf to not display the empty image placeholder until it arrives from api call -->
                <img *ngIf="this.brokerLogo" src="{{this.brokerLogo}}" alt="Broker logo">
            </a>
            <ng-container *ngIf="!(partnerUrlFr || partnerUrlNl)">
                <img *ngIf="coBrandImage" src="{{ coBrandImage }}" alt="co-brand" class="navbar-cobrand" />
            </ng-container>
            <ng-container *ngIf="partnerUrlFr || partnerUrlNl">
                <a class="navbar-coBrand" data-overlay-trigger="true"
                    [attr.href]="currentLanguage==='nl' ? 'https://'+partnerUrlNl : 'https://'+partnerUrlFr">
                    <img src="{{coBrandImage}}" alt="Broker logo">
                </a>
            </ng-container>

        </div>
    </header>
    <app-dynamic-header *ngIf="inCustomerZone"></app-dynamic-header>
    <div *ngIf="showBanner" class="broadcast-banner">
        <div class="broadcast-inner">
            <img src="assets/images/warning-icon.svg" alt="Icon" />
            <span
                innerHTML="{{ currentLanguage ==='fr' ? (broadcastContent.BodyFR | punctuationWrap) : broadcastContent.BodyNL }}"></span>
        </div>
    </div>
    <div class="promo-container" *ngIf="showPromoBanner" [ngClass]="{
            'promobanner-profile': currentScreenType === BroadcastScreenType.Profile,
            'promobanner-contract-details': currentScreenType === BroadcastScreenType.ContractDetails
        }">
        <div class="promo-banner">
            <div class="banner-left">
                <picture>
                    <source [attr.srcset]="broadcastContent.PromoBannerDetails.PromoBannerDesktopImage"
                        media="(min-width: 768px)">
                    <source [attr.srcset]="broadcastContent.PromoBannerDetails.PromoBannerMobileImage"
                        media="(max-width: 767px)">
                    <img [attr.src]="broadcastContent.PromoBannerDetails.PromoBannerDesktopImage" alt="Banner Image">
                </picture>
            </div>
            <div class="banner-right">
                <div class="banner-header">
                    <div class="icon-title">
                        <img class="icon-class" src="{{broadcastContent.PromoBannerDetails.PromoBannerIcon}}" />
                        <span class="title" innerHTML="{{ currentLanguage ==='fr' ? (broadcastContent.TitleFR) :
                            broadcastContent.TitleNL}}"></span>
                    </div>
                    <a target="_blank" href="{{ currentLanguage ==='fr' ? (broadcastContent.PromoBannerDetails.LandingPageLinkFR) :
                        broadcastContent.PromoBannerDetails.LandingPageLinkNL}}" class="link"
                        [innerHTML]="'BroadcastMessage.MoreInformation' | translate"></a>
                </div>
                <div class="banner-body-container">
                    <div class="banner-body">
                        <span [innerHTML]="broadcastBodyText"></span>
                    </div>
                    <a target="_blank" href="{{ currentLanguage ==='fr' ? (broadcastContent.PromoBannerDetails.LandingPageLinkFR) :
                            broadcastContent.PromoBannerDetails.LandingPageLinkNL}}" class="link"
                        [innerHTML]="'BroadcastMessage.MoreInformation' | translate"></a>
                </div>

            </div>
        </div>
    </div>
    <div class="contentContainer" [ngClass]="{'container-pt': showBanner}">
        <main class="content clearfix">
            <router-outlet></router-outlet>
        </main>
        <footer ag-webtemplate-footer-wizard (languageSelected)="switchLanguage($event)">
        </footer>
    </div>
    <app-help-widget *ngIf="isWidgetVisible"></app-help-widget>
    <div class="container positive-line">
        <i class="glyphicon-ag-positive-line positive-line-border" aria-hidden="true"></i>
        <i class="glyphicon-ag-positive-line positive-line-background" aria-hidden="true"></i>
        <img src="assets/images/logo-aginsurance.svg" class="positive-line-logo" aria-hidden="true" alt="AG" />
    </div>
</div>
<app-sil-loading></app-sil-loading>

<app-modal [customClass]="'broadcast-message-popup confirmation-modal'" [noHeader]="false" [showButton]="false"
    title="{{ currentLanguage ==='fr' ? broadcastContent?.TitleFR : broadcastContent?.TitleNL }}" [strictClose]="true"
    (modalClosed)="onClosePopup()" #broadcastModal>
    <div class="popup-desc text-left">
        <p
            innerHTML="{{ currentLanguage === 'fr' ? (broadcastContent?.BodyFR | punctuationWrap) : broadcastContent?.BodyNL }}">
        </p>
    </div>
    <div class="sil-modal-CTA-wrapper col-xs-12">
        <button class="btn btn-primary" (click)="onClosePopup()"
            [innerHTML]="'BroadcastMessage.Btn' | translate | punctuationWrap"></button>
    </div>
</app-modal>